import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { differenceBy } from 'lodash';
import { Button } from './styles/Button.styled';
import {
  TabPanelBlock,
  TabPanel,
  EventUL,
  ListTab,
  EventInfo,
  EventLink,
  CtaButton,
} from './styles/BannerAsideTabBlock.styled';
import CalendarIcon from '../assets/svg/calendarw.svg';
import { convertMonthToAr, dateToStringNoYear } from '../helpers/date-convert';
import Events from '../services/Events';
import { getTranslationByKey } from '../helpers/translation-helper';
import { DWTCContext } from '../utils/context';

export default function AsideMenuEventSearch({ lang, isVisible, dir }) {
  const isArabic = lang === 'ar';
  const { translations } = React.useContext(DWTCContext);
  const currDate = new Date();
  const events = new Events();
  const eventsFiltered = events.get(lang);
  const [eventsList, setEventsList] = React.useState(eventsFiltered);

  const variants = {
    isOpen: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.3,
        ease: 'linear',
      },
    },
    isClosed: {
      opacity: 0,
      x: 300,
      transition: {
        duration: 0.3,
        ease: 'linear',
      },
    },
  };

  React.useEffect(() => {
    let filteredEvents = eventsList;
    filteredEvents = eventsList.filter((event) => new Date(event.endDate) >= currDate);
    filteredEvents.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
    setEventsList(filteredEvents);
  }, []);

  return (
    isVisible && (
      <AnimatePresence>
        <TabPanelBlock variants={variants} initial="isClosed" animate="isOpen" exit="isClosed">
          <TabPanel dir={differenceBy}>
            <EventUL>
              {eventsList.slice(0, 2).map((event) => (
                <ListTab dir={dir}>
                  <p className="ev-date" dir={dir}>
                    <CalendarIcon />
                    {isArabic
                      ? convertMonthToAr(dateToStringNoYear(event.startDate))
                      : dateToStringNoYear(event.startDate)}
                  </p>
                  <EventInfo dir={dir}>
                    <p className="ev-tag" dir={dir}>
                      {getTranslationByKey(translations, event.eventType)}
                    </p>
                    <p className="ev-title" dir={dir}>
                      <EventLink to={event.url} dir={dir}>
                        {event.title}
                      </EventLink>
                    </p>
                  </EventInfo>
                </ListTab>
              ))}
              <CtaButton>
                <Button stylevariant="secondaryOutline" to={`/${lang}/events/`} dir={dir}>
                  {isArabic ? 'اكتشف المزيد' : 'Explore More'}
                </Button>
              </CtaButton>
            </EventUL>
          </TabPanel>
        </TabPanelBlock>
      </AnimatePresence>
    )
  );
}
